"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonDropdown = void 0;
var React = require("react");
var keyboard = require("../../_Core/Keyboard");
var IconCaption_1 = require("../../Indicators/IconCaption/IconCaption");
var ButtonDropdown_styles_1 = require("./ButtonDropdown.styles");
var ButtonDropdown = /** @class */ (function (_super) {
    __extends(ButtonDropdown, _super);
    function ButtonDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.CloseDropdown = function () {
            _this.setState({ Expanded: false });
        };
        _this.renderDropdown = function () {
            return ([
                React.createElement(ButtonDropdown_styles_1.Background, { key: "background", onClick: _this.handleClick }),
                React.createElement(ButtonDropdown_styles_1.Dropdown, { "aria-label": _this.props.Caption, ref: _this.getDropdownRef, key: "dropdown", tabIndex: -1, style: { maxHeight: "calc(90vh - " + _this.buttonBottom + "px)" } }, _this.props.children),
            ]);
        };
        _this.handleKeyPresses = function (e) {
            if (keyboard.IsEscape(e)) {
                _this.CloseDropdown();
                _this.button.focus();
            }
        };
        _this.getDropdownRef = function (dropdown) {
            _this.dropdown = dropdown;
        };
        _this.getButtonRef = function (button) {
            _this.button = button;
        };
        _this.handleClick = function () {
            var showDropdown = function () {
                var changeFocus = false;
                _this.setState(function (prevState) {
                    changeFocus = (prevState.Expanded === false);
                    if (prevState.Expanded && _this.props.OnClose) {
                        _this.props.OnClose();
                    }
                    return {
                        Expanded: !prevState.Expanded,
                    };
                }, function () {
                    if (changeFocus) {
                        _this.dropdown.focus();
                    }
                });
            };
            if (_this.props.OnClick) {
                var result = _this.props.OnClick();
                if (result) {
                    showDropdown();
                }
            }
            else {
                showDropdown();
            }
        };
        _this.state = {
            Expanded: false,
        };
        return _this;
    }
    ButtonDropdown.prototype.componentDidMount = function () {
        var position = this.button.getBoundingClientRect();
        this.buttonBottom = position.bottom;
    };
    ButtonDropdown.prototype.render = function () {
        return (React.createElement(ButtonDropdown_styles_1.Container, { onKeyUp: this.handleKeyPresses },
            React.createElement(ButtonDropdown_styles_1.Button, { type: "button", ref: this.getButtonRef, onClick: this.handleClick, "aria-haspopup": true, "aria-expanded": this.state.Expanded },
                React.createElement(IconCaption_1.IconCaption, { Icon: this.props.Icon, Caption: this.props.Caption }),
                this.props.Count && this.props.Count > 0 ? React.createElement(ButtonDropdown_styles_1.Count, null, this.props.Count) : null),
            this.state.Expanded ? this.renderDropdown() : null));
    };
    return ButtonDropdown;
}(React.PureComponent));
exports.ButtonDropdown = ButtonDropdown;
